<template>
	<div class="settings">
		<div class="field">
			<b-checkbox v-model="doubplePrint">
				Double Print
			</b-checkbox>
			<br /><br />
			<div class="radioCheck">
				<b-radio v-model="logo" name="name" native-value="bd">Healthy U Logo</b-radio>
			</div>

			<div>
				<div class="server-settings">
					<div class="settings-wrapper">
						<div class="label">Server Setting</div>
						<div>
							<input name="serverSetting" placeholder="Server Setting" v-model="serverSetting" autocomplete="off" />
						</div>
						<div>
							<div class="button" @click="setServerSetting()">
								Update
							</div>
						</div>
						<div>
							<div class="button" @click="resetServerSetting()">
								RESET
							</div>
						</div>
					</div>
				</div>

				<div v-if="secretePass || manager">
					<div class="settings-wrapper">
						<div class="label">Restore Products</div>
						<div>
							<div class="button" @click="restoreProducts()">
								Retore
							</div>
						</div>
					</div>

					<div class="settings-wrapper">
						<div class="label">Restore Brand</div>
						<div>
							<div class="button" @click="restoreBrand()">
								Retore
							</div>
						</div>
					</div>

					<div class="settings-wrapper">
						<div class="label">Restore Staffs</div>
						<div>
							<div class="button" @click="restoreStaff()">
								Retore
							</div>
						</div>
					</div>

					<div class="settings-wrapper">
						<div class="label">Restore Promotion</div>
						<div>
							<div class="button" @click="restorePromotion()">
								Retore
							</div>
						</div>
					</div>

					<div class="settings-wrapper">
						<div class="label">Restore Categories</div>
						<div>
							<div class="button" @click="restoreCategory()">
								Retore
							</div>
						</div>
					</div>

					<div class="settings-wrapper">
						<div class="label">Restore Orders (Download)</div>
						<div>
							<div class="button" @click="restoreOrder()">
								Retore
							</div>
						</div>
					</div>

					<div class="settings-wrapper">
						<div class="label">Backup Orders (Upload)</div>
						<div>
							<div class="button" @click="backupOrder()">
								Retore
							</div>
						</div>
					</div>

					<div class="settings-wrapper">
						<div class="label">Sync</div>
						<div>
							<div class="button" @click="sync()">
								Retore
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'settings',

	data: function() {
		return {
			doubplePrint: this.$store.state.doublePrint,
			manager: false,
			secretePass: false,
			serverSetting: this.$store.state.serverSetting,
			logo: this.$store.state.logo
		}
	},

	watch: {
		doubplePrint: function(newVal) {
			this.$store.dispatch('set_double_print', newVal)
			this.$swal.fire({ position: 'top-end', icon: 'success', title: 'Printer setting is updated', showConfirmButton: false, timer: 1500 })
		},

		logo: function(newVal) {
			this.$store.dispatch('set_logo', newVal)
			this.$swal.fire({ position: 'top-end', icon: 'success', title: 'Logo has been updated', showConfirmButton: false, timer: 1500 })
		}
	},

	mounted: async function() {
		await this.getUserRole()

		if (this.$route.query.a) {
			if (this.$route.query.a == 'zinotech') {
				this.secretePass = true
			}
		}
	},

	methods: {
		// Reset server setting
		resetServerSetting: async function() {
			const newSetting = this.$config.serverUrl
			await this.$store.dispatch('set_server_setting', newSetting)

			this.serverSetting = newSetting

			this.$swal.fire('Reset!', 'Updated server setting!', 'success')
		},

		// To save server setting
		setServerSetting: async function() {
			if (this.serverSetting !== null) {
				await this.$store.dispatch('set_server_setting', this.serverSetting)

				this.$swal.fire('Updated!', 'Updated server setting!', 'success')
			}
		},

		restoreStaff: async function() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: 'Are you sure you want to restore staffs?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, Reset!'
				})
				.then(async result => {
					if (result.value) {
						await this.sync()
						await this.$api.restoreStaff()
					}
				})
		},

		restoreProducts: async function() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: 'Are you sure you want to restore products?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, Reset!'
				})
				.then(async result => {
					if (result.value) {
						await this.sync()
						await this.$api.restoreProducts()
					}
				})
		},

		restoreBrand: async function() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: 'Are you sure you want to restore brands?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, Reset!'
				})
				.then(async result => {
					if (result.value) {
						await this.sync()
						await this.$api.restoreBrand()
					}
				})
		},

		restoreCategory: async function() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: 'Are you sure you want to restore categories?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, Reset!'
				})
				.then(async result => {
					if (result.value) {
						await this.sync()
						await this.$api.restoreCategory()
					}
				})
		},

		restorePromotion: async function() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: 'Are you sure you want to restore promotions?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, Reset!'
				})
				.then(async result => {
					if (result.value) {
						await this.sync()
						await this.$api.restorePromotion()
					}
				})
		},

		restoreOrder: async function() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: 'Are you sure you want to restore orders?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes!'
				})
				.then(async result => {
					if (result.value) {
						await this.sync()
						await this.$api.restoreOrder()
					}
				})
		},

		backupOrder: async function() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: 'Are you sure you want to upload orders?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes!'
				})
				.then(async result => {
					if (result.value) {
						await this.sync()
						await this.$api.backupOrder()
					}
				})
		},

		sync: async function() {
			await this.$api.syncNow()
		},

		// Get role
		getUserRole: async function() {
			const apiGetOwnProfile = await this.$api.getOwnProfile({})

			if (apiGetOwnProfile) {
				const matchRole = apiGetOwnProfile.data.roles.find(role => {
					return role == 'shop_manager'
				})

				if (matchRole) {
					this.manager = true
				} else {
					this.manager = false
				}
			}
		}
	}
}
</script>

<style scoped>
.settings {
	text-align: left;
	padding: 20px;
}

.server-settings input {
	border: 1px solid #ccc;
	border-radius: 5px;
	height: 40px;
	width: 350px;
	padding: 0 10px;
	font-size: 14px;
	margin-bottom: 20px;
}

.settings-wrapper {
	margin: 20px 0;
	width: 750px;
	display: grid;
	grid-template-columns: 150px 1fr 100px 100px;
	grid-gap: 10px;
}

.settings-wrapper .label {
	padding-top: 7px;
	font-weight: normal;
}

.button {
	padding: 20px 20px;
	background-color: #ff4343;
	color: #fff;
	border: none;
	font-size: 14px;
	border-radius: 5px;
	cursor: pointer;
	outline: 0;
}
</style>
